<template>
  <div class="paginations">
    <div class="pageSizes">
      <!-- <div  class="firstPage" @click="page(1)">首页</div> -->
      <div  class="firstPage" @click="getDatass(1)">首页</div>
      <div  class="pravPage" @click="prav">上</div>
      <div  class="pageIndex" :class="pag==cur?'active':''" v-for="(pag, index) in conPages" :key="index" @click="page(pag)">{{ pag }}</div>
      <div  class="nextPage" @click="next">下</div>
      <!-- <div  class="endPage" @click="page(conPages)">尾页</div> -->
      <div  class="endPage" @click="getDatass(conPages)">尾页</div>
      <!-- href="#" Information_content -->
    </div>
  </div>
</template>
<style lang="scss">
.paginations{
  text-align: center;
  .pageSizes{
    display: flex;
    
    .pravPage,.nextPage,.firstPage,.endPage,.pageIndex{
      width: 60px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #d9d9d9;
      cursor: pointer;
    }
    .pravPage,.nextPage,.pageIndex{
      width: 40px;
      margin: 0 10px;
    }
  }
  .active{
    background: #005bab;
    color: #fff;
    width: 40px;
    height: 40px;
  }
}
</style>
<script>
import $ from 'jquery'
export default {
  name: "paginations",
  props: {
    // pageList: [],
    current: "",
  },
  data() {
    return {
      pageList:[],
      conPages: "", //总页数
      totalElements:'',//总条数
      cur: 1, //当前页
      pageSize: 3, //每页展示的数据条数
      showPage: [], //每页展示的内容
    }
  },
  created() {
    
  },
  mounted(){
    this.getDatass(this.cur)
    // console.log(this.pageList);
    
  },
  methods: {
    getDatass(page) {
      var ts = this
      ts.cur = page
      $.ajax({
          type: "post",
          data: JSON.stringify({}),
          url: `http://120.53.104.103//bossint/findAllNewsPage/${page-1}/4`,
          dataType: "json",
          contentType: "application/json;charset=UTF-8",
          success: function (res) {
          // console.log(res)
          ts.pageList = res.content
          // ts.conPages = Math.ceil(ts.pageList.length / ts.current)
          // ts.page(ts.cur)
          ts.totalElements = res.totalElements
          ts.conPages = res.totalPages
          ts.$emit("getData", res.content)
          },
          error: function () {
          // alert("出错啦...")
          },
      })
    },
    setData() {
      this.$emit("getData", this.current)
    },
    page(val) {
      this.cur = val //当前页
      // var list = (this.cur - 1) * this.current
      // this.showPage = this.pageList.slice(list, list + this.current)
      // this.$emit("getData", this.showPage)
      this.getDatass(this.cur)
    },
    prav() {
      if (this.cur != 1) {
        this.cur--
        // this.page(this.cur)
        this.getDatass(this.cur)
      }
    },
    next() {
      if (this.cur < this.conPages) {
        this.cur++
        // this.page(this.cur)
        this.getDatass(this.cur)
      }
    },
    
  },
}
</script>
<style scoped></style>
